// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../node_modules/rescript/lib/es6/caml_option.js";
import * as FormInput$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as Timestamp$Catalyst from "../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as MomentUtils$Catalyst from "../../../node_modules/@porterin/catalyst/src/entities/date/moment-utils/MomentUtils.bs.js";
import * as FomDateInputTs$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FomDateInputTs.bs.js";
import * as FormTimeInputTs$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormTimeInputTs.bs.js";
import * as FormKeyInputTimeTs$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormKeyInputTimeTs.bs.js";
import * as FormDateTimeInputTs$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FormDateTimeInputTs.bs.js";

function TestComponent(Props) {
  MomentUtils$Catalyst.setTz("Asia/Muscat");
  var match = React.useState(function () {
        
      });
  var setTs = match[1];
  var ts = match[0];
  var maxTs = Timestamp$Catalyst.getDateTimeAfterElapsedTime(3.0, /* Days */4, Timestamp$Catalyst.now(undefined));
  var minTs = Timestamp$Catalyst.getDateTimeBeforeElapsedTime(4.0, /* Days */4, Timestamp$Catalyst.now(undefined));
  return React.createElement("div", undefined, React.createElement(FomDateInputTs$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Time", (function (param) {
                          
                        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  date_props: FomDateInputTs$Catalyst.make_props(ts, Caml_option.some(minTs), Caml_option.some(maxTs), (function (ts) {
                          return Curry._1(setTs, (function (param) {
                                        return Caml_option.some(ts);
                                      }));
                        }), "DD-MM-YYYY hh:mm A", true, undefined, undefined, undefined)
                }), React.createElement(FormDateTimeInputTs$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Time", (function (param) {
                          
                        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  date_props: {
                    value: ts,
                    minDate: Caml_option.some(minTs),
                    maxDate: Caml_option.some(maxTs),
                    onChange: (function (ts) {
                        return Curry._1(setTs, (function (param) {
                                      return Caml_option.some(ts);
                                    }));
                      }),
                    format: "DD-MM-YYYY hh:mm A",
                    isDisabled: false,
                    onClear: (function (param) {
                        return Curry._1(setTs, (function (param) {
                                      
                                    }));
                      })
                  }
                }), React.createElement(FormTimeInputTs$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Time", (function (param) {
                          
                        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  time_props: {
                    value: ts,
                    onChange: (function (ts) {
                        return Curry._1(setTs, (function (param) {
                                      return Caml_option.some(ts);
                                    }));
                      })
                  }
                }), React.createElement(FormKeyInputTimeTs$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("Time", (function (param) {
                          
                        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  time_props: {
                    value: ts,
                    onChange: (function (ts) {
                        return Curry._1(setTs, (function (param) {
                                      return ts;
                                    }));
                      }),
                    format: "hh:mm A",
                    ampm: true,
                    isDisabled: false
                  }
                }));
}

var make = TestComponent;

export {
  make ,
  
}
/* react Not a pure module */
